import { getMaxGuestsForPaperStorage } from "./qualityConfig.js";

/**
 * Maps a product from ProductContainer format to ProductCard format
 * @param {Object} product - The product from API
 * @param {Object} options - Optional configuration for package matching
 * @param {string} options.printType - "print" or "digital"
 * @param {string} options.guestCount - Guest count for filtering
 */
export function mapProductToCard(product, options = {}) {
  const { printType, guestCount } = options;

  // Extract relevant data from product
  const {
    PhotoboothName,
    PhotoboothImage,
    Stars,
    NumberFeedbacks,
    LinkFeedback,
    CamType,
    LightType,
    Props,
    ControlLiveView,
    ControlTouch,
    ControlRemote,
    PrintLayoutsYesNo,
    Background,
    DigitalHandy,
    DigitalOnlineGalerie,
    DigitalUSB,
    PostDelivery,
    PostDeliveryCosts,
    PostDeliveryShippingStart,
    PostDeliveryShippingEnd,
    SelfDelivery,
    SelfDeliveryDaysBeforeEvent,
    SelfDeliveryZip,
    SelfDeliveryCity,
    ShippingRanges,
    CustomerPickUp,
    CustomerPickUpZip,
    CustomerPickUpCity,
    FreeSchedule,
    FreeScheduleDays,
    GuruScore,
    GuruTestReport,
    PartnerName,
    KlickWert,
    Label,
    LabelTooltip,
    Sponsored,
    Packages,
    PhotoboothPrice,
    URL,
    Slug,
    Intern,
    PackageName,
    VoucherCode,
    VoucherValue,
    VoucherSpecial,
  } = product;

  // Build packages array from the Packages in the product
  const guestThreshold =
    printType === "print" && guestCount ? parseInt(guestCount, 10) : null;

  const packages = (Packages || [])
    .map((pkg) => {
      // Bewerte ob Package zum PrintType passt
      let matched = true;

      // Filter nach Print-Typ
      if (printType === "print") {
        matched = pkg.Print === true;
      } else if (printType === "digital") {
        matched = pkg.Print === false;
      }

      // Zusätzlich: Gästezahl-Filter für Print-Packages
      if (
        matched &&
        pkg.Print === true &&
        guestThreshold &&
        guestThreshold !== 50
      ) {
        const paperSize = pkg.Printer?.PaperStorageSize;
        const maxGuests = getMaxGuestsForPaperStorage(paperSize);
        if (maxGuests !== null && maxGuests !== undefined) {
          matched = maxGuests >= guestThreshold;
        }
      }

      return {
        priceLabel: `${(PhotoboothPrice + pkg.PackagePrice)
          .toFixed(2)
          .replace(".", ",")}€`,
        paperStorageSize: pkg.Printer?.PaperStorageSize || null,
        isPrintFlatrate: pkg.SpecialPrintFlatrate || false,
        packageName: pkg.PackageName || "Standard",
        totalPrice: PhotoboothPrice + pkg.PackagePrice, // Für Sortierung
        matched: pkg.matched !== undefined ? pkg.matched : matched, // ✅ Nutze existierendes matched oder berechne es
      };
    })
    .sort((a, b) => a.totalPrice - b.totalPrice); // Sortiere nach Preis: günstig → teuer

  // ✅ Props und Background aus den Packages prüfen (wenn IRGENDEIN Package sie hat)
  const hasProps = (Packages || []).some((pkg) => pkg.Props === true);
  const hasBackground = (Packages || []).some((pkg) => pkg.Background === true);

  return {
    name: PartnerName || PhotoboothName,
    partnername: PartnerName || PhotoboothName,
    image: PhotoboothImage,
    stars: Stars || 0,
    numberOfFeedbacks: NumberFeedbacks || 0,
    linkFeedback: LinkFeedback || "#",
    guruScore: GuruScore || 0,
    guruTestReport: GuruTestReport || false,
    href: PartnerName
      ? `/fotobox-test/${PartnerName.toLowerCase().replace(/\s+/g, "-")}`
      : "#",
    url: URL || "#",
    slug: Slug || null,
    // Was ein Klick zu diesem Partner einbringt (Teil B3) — der Knopf
    // meldet ihn beim Clickout an den Tag Manager.
    klickWert: typeof KlickWert === "number" ? KlickWert : null,
    sponsored: Sponsored || false,
    label: Label || null,
    labelTooltip: LabelTooltip || null,

    // Equipment
    camType: CamType || "Keine Info",
    lightType: LightType || "Keine Info",

    // Extras
    props: hasProps,
    controlLiveView: ControlLiveView || false,
    controlTouch: ControlTouch || false,
    controlRemote: ControlRemote || false,
    printLayouts: PrintLayoutsYesNo || false,
    background: hasBackground,

    // Digital
    digitalPhone: DigitalHandy || false,
    digitalOnlineGallery: DigitalOnlineGalerie || false,
    digitalUSB: DigitalUSB || false,

    // Delivery
    postDelivery: PostDelivery || false,
    postDeliveryCosts: PostDeliveryCosts || 0,
    postDeliveryShippingStart: PostDeliveryShippingStart || null,
    postDeliveryShippingEnd: PostDeliveryShippingEnd || null,

    selfDelivery: SelfDelivery || false,
    selfDeliveryDaysBeforeEvent: SelfDeliveryDaysBeforeEvent || 0,
    selfDeliveryZip: SelfDeliveryZip || null,
    selfDeliveryCity: SelfDeliveryCity || null,
    shippingRanges: ShippingRanges || [],

    customerPickUp: CustomerPickUp || false,
    customerPickUpZip: CustomerPickUpZip || null,
    customerPickUpCity: CustomerPickUpCity || null,

    // Schedule
    freeSchedule: FreeSchedule || false,
    freeScheduleDays: FreeScheduleDays || 0,

    // Packages
    packages: packages,

    // OfferButton Properties
    Intern: Intern || false,
    PackageName: PackageName || "Standard",
    voucherCode: VoucherCode || "",
    voucherValue:
      typeof VoucherValue === "number"
        ? VoucherValue
        : Number(VoucherValue) || 0,
    voucherSpecial: VoucherSpecial || "",
  };
}
